import { render, staticRenderFns } from "./BrowseCatalogueEquipment.vue?vue&type=template&id=b2280694&scoped=true"
import script from "./BrowseCatalogueEquipment.vue?vue&type=script&lang=js"
export * from "./BrowseCatalogueEquipment.vue?vue&type=script&lang=js"
import style0 from "./BrowseCatalogueEquipment.vue?vue&type=style&index=0&id=b2280694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2280694",
  null
  
)

export default component.exports